import React from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import './ProfileMediaSkeleton.css';

/**
 * Mirrors ProfileMedia page:
 *  - Header: back arrow + "Your Media"
 *  - Col lg-3 sidebar (3 nav items) + Col lg-9 media grid
 */
const ProfileMediaSkeleton: React.FC = () => (
  <>
    {/* Header */}
    <div className="d-flex justify-content-start align-items-center px-3 px-md-4 py-3 mb-3">
      <div className="d-flex align-items-center gap-2">
        <Skeleton circle width={32} height={32} />
        <Skeleton width={120} height={28} borderRadius={6} />
      </div>
    </div>

    <Container fluid className="p-0">
      <Row className="g-0">
        {/* Sidebar */}
        <Col lg={3} className="d-none d-lg-block border-end p-3 bg-white">
          {['Profile', 'Pitch', 'Chat'].map((_, i) => (
            <div key={i} className="d-flex align-items-center rounded-2 p-3 mb-2">
              <Skeleton circle width={20} height={20} style={{ marginRight: 12, flexShrink: 0 }} />
              <Skeleton width={80} height={14} borderRadius={6} />
            </div>
          ))}
        </Col>

        {/* Media grid */}
        <Col xs={12} lg={9} className="ps-4">
          <Card className="border-0 shadow-sm">
            <Card.Body className="p-4">
              <div className="d-flex gap-3 flex-wrap">
                {[...Array(6)].map((_, i) => (
                  <Skeleton key={i} width={160} height={120} borderRadius={8} />
                ))}
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  </>
);

export default ProfileMediaSkeleton;
